import { useConfigurationOptionsContext } from "app/providers/DoorOptionsProvider";
import { useDealerDiscounts } from "./useDealerDiscounts";
import { zakelijkProfielCodes } from "features/option-controls/door-width-controls/ZakelijkHelper";

export const useDealerPriceInformations = () => {
  const { layout, handle, color, selectedDoor, glass, calculateExtrasPrice } =
    useConfigurationOptionsContext();

  const { isDealerDiscountsLoading, businessDoorDiscount } = useDealerDiscounts(
    selectedDoor?.price ?? 0,
  );

  // Calculate the total price for the product
  const getTotalPriceZakelijkProduct = () => {
    let price = 0;
    price += selectedDoor?.price || 0;

    if (zakelijkProfielCodes.includes(selectedDoor?.code ?? "") && layout) {
      price += layout.price;
    }
    if (color) {
      price += color.price;
    }
    if (glass) {
      price += glass.price * (selectedDoor?.configuration.nElements || 1);
    }
    if (handle) {
      price += handle.price;
    }

    const extrasPrice = calculateExtrasPrice();
    price += extrasPrice;

    return price;
  };

  const totalConfiguredPrice = getTotalPriceZakelijkProduct();

  // Total price with discount
  const totalZakelijkDiscounted =
    getTotalPriceZakelijkProduct() -
    getTotalPriceZakelijkProduct() * (businessDoorDiscount / 100);

  // Format the total price with discount
  const totalZakelijkPriceDiscounted = "€" + totalZakelijkDiscounted.toFixed(2);
  // Format the totaal price
  const totalZakelijkPrice = "€" + totalConfiguredPrice.toFixed(2);

  // Calculate the VAT amount based on the total price after discount
  const vatAmount = ((totalZakelijkDiscounted * 21) / 121).toFixed(2);

  // Calculate the saved amount
  const savedAmount = (totalConfiguredPrice - totalZakelijkDiscounted).toFixed(
    2,
  );
  //Return values
  return {
    savedAmount,
    vatAmount,
    totalZakelijkPrice,
    totalZakelijkPriceDiscounted,
    isDealerDiscountsLoading,
  };
};
